import { useTheme, Box } from '@mui/material';
import {
  allExpanded,
  defaultStyles,
  darkStyles,
  JsonView,
} from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

export const JsonViewer = ({
  data,
}: {
  data: Parameters<typeof JsonView>[0]['data'];
}) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <Box sx={{ '& > div': { background: 'transparent' } }}>
      <JsonView
        data={data}
        shouldExpandNode={allExpanded}
        style={isDarkMode ? darkStyles : defaultStyles}
      />
    </Box>
  );
};
